import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, IconButton} from '@material-ui/core';
import {ArrowBackIos} from '@material-ui/icons';
import {
    saveAbnormalRecord,
    uploadReceiveImage,
    getSupplyCenterList,
    getVagueSearchList,
    getScrapType,
    checkF1Number,
    e1GetSkuList,
    getScrapParams,
} from 'Actions/host';
import {openNotification} from 'Actions/notification';
import BasicButton from 'Components/common/BasicButton';
import BasicInput from 'Components/common/BasicInput';
import SelectInput from 'Components/common/SelectInput';
import BasicTextArea from 'Components/common/BasicTextArea';
import Anchor from 'Components/common/Anchor';
import Counter from 'Components/counter/Counter';
import Select from 'Components/common/Select';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';
import {loadLanguage} from 'Utils/jwtUtil';
class AbnormalRecordSave extends Component {
    state = {
        sku: '',
        kitSku: '',
        abnormalDescription: '',
        quantity: 1,
        lotNo: '',
        expireDate: '',
        pic: '',
        chooseImage: null,
        supplyCenterId: '',
        type: '',
        eoneNumber: '',
        expressNumber: '',
        loading: false,
        skuData: [],
        lotData: [],
        SClist: [],
        scrapTypelist: [],
        expressNumList: [],
        refundSkuList: [],
        lotList: [],
        baseQuantity: 1,
        refund_sku: [],
        remarkNum: 0,
    };

    componentDidMount() {
        this.props.getSupplyCenterList();
        this.props.getScrapType();
    }

    handleChange = (name, value) => {
        this.setState({[name]: value});
        if (name == 'sku') {
            let timer = null;
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                if (typeof value == 'string') {
                    this.getSKU(value);
                } else {
                    this.getSKU(value['fullName']);
                    this.setState({
                        lotData: value['lot'],
                        lotNo: value['lot'][0]['key'],
                    });

                    if (
                        value['lot'] &&
                        value['lot'].length > 0 &&
                        value['lot'][0]['lotExpirationDate']
                    ) {
                        this.setState({
                            expireDate: value['lot'][0]['lotExpirationDate'],
                        });
                    } else {
                        this.setState({
                            expireDate: '',
                        });
                    }
                }
            }, 900);
        }
        const {lotData} = this.state;
        if (name == 'lotNo') {
            if (lotData && lotData.length > 0) {
                lotData.forEach((item) => {
                    if (item['key'] == value) {
                        this.setState({
                            expireDate: item.lotExpirationDate,
                            sku: item.kitDisplay,
                            kitSku: item.kitSku,
                            lotNo: value,
                        });
                    }
                });
            }
        }

        if (name == 'supplyCenterId') {
            this.searchData(value, 'sc');
        }

        if (name === 'abnormal_scrapSort') {
            let currentabnormalDescription = value.fullName;
            if (value.key === 'OTHER_EXCEPTION') {
                currentabnormalDescription = '';
            }
            this.setState({
                type: value,
                abnormalDescription: currentabnormalDescription,
            });

            this.setState({
                sku: '',
                kitSku: '',
                refundSkuList: [],
                eoneNumber: '',
                expressNumber: '',
                lotNo: '',
                lotList: [],
                expireDate: '',
                quantity: 1,
                scrapTypelist: [],
                expressNumList: [],
                baseQuantity: 1,
            });
        }

        if (name === 'abnormal_f1OrderNumber') {
            this.setState({
                eoneNumber: value && value.trim(),
            });
            if (!value && value.length == '') {
                this.setState({
                    sku: '',
                    kitSku: '',
                    expressNumber: '',
                    refundSkuList: [],
                    eoneNumber: '',
                    lotNo: '',
                    lotList: [],
                    expireDate: '',
                    quantity: 1,
                    scrapTypelist: [],
                    expressNumList: [],
                    baseQuantity: 1,
                    refund_sku: [],
                });
            }
        }

        if (name === 'abnormal_DnOrderNumber') {
            this.setState(
                {
                    expressNumber: value && value.id && value.id.trim(),
                },
                () => {
                    this.e1GetSku();
                },
            );
            this.searchData(value, 'dn');

            if (!value && !value.id) {
                this.setState({
                    sku: '',
                    kitSku: '',
                    lotNo: '',
                    expireDate: '',
                    quantity: 1,
                    refund_sku: [],
                });
            }
        }

        if (name === 'refund_sku') {
            this.setState(
                {
                    sku: value && value.displaySku && value.displaySku.trim(),
                    kitSku: value && value.fatherSku && value.fatherSku.trim(),
                    refund_sku: value,
                },
                () => {
                    this.getScrapParams();
                },
            );
            this.searchData(value, 'sku');
        }

        if (name === 'refund_lot') {
            this.setState({
                lotNo: (value && value.lot && value.lot.trim()) || value,
                expireDate: value && value.lotExpirationDate,
                baseQuantity: value && value.quantity,
            });
            this.searchData(value, 'lot');
        }
    };

    onBlur = () => {
        const {eoneNumber} = this.state;
        if (eoneNumber && eoneNumber.length > 0) {
            this.checkF1NumberList(eoneNumber);
        }
    };

    getScrapParams = () => {
        const {eoneNumber, expressNumber, refund_sku} = this.state;
        const params = {
            eoneNumber,
            shipmentNumber: expressNumber,
            sku: refund_sku && refund_sku.sku && refund_sku.sku,
        };
        if (
            expressNumber &&
            expressNumber.length > 0 &&
            eoneNumber &&
            eoneNumber.length > 0
        ) {
            this.props.getScrapParams(params).then((res) => {
                if (res && res.data && res.data.length > 0) {
                    this.setState({
                        lotNo: res.data[0].lot,
                        expireDate: res.data[0].lotExpirationDate,
                        baseQuantity: res.data[0].quantity || 1,
                    });
                } else {
                    this.setState({
                        lotNo: '',
                        expireDate: '',
                        quantity: 1,
                        baseQuantity: '',
                    });
                }
            });
        }
    };

    e1GetSku = () => {
        const {eoneNumber, expressNumber} = this.state;
        const params = {
            eoneNumber,
            shipmentNumber: expressNumber,
        };
        if (
            expressNumber &&
            expressNumber.length > 0 &&
            eoneNumber &&
            eoneNumber.length > 0
        ) {
            this.props.e1GetSkuList(params).then((res) => {
                if (res && res.data && res.data.length > 0) {
                    this.setState(
                        {
                            sku: res.data[0].displaySku,
                            kitSku: res.data[0].fatherSku,
                            refund_sku: res.data[0],
                        },
                        () => {
                            this.getScrapParams();
                        },
                    );
                }
            });
        }
    };

    clearF1data = (info) => {
        this.props.openNotification(T(info), 'danger');
        this.setState({
            expressNumList: [],
            expressNumber: '',
            sku: '',
            kitSku: '',
            refundSkuList: [],
            refund_sku: [],
            lotNo: '',
            lotList: [],
            expireDate: '',
            quantity: 1,
            baseQuantity: '',
        });
    };

    checkF1NumberList = (value) => {
        const params = {
            eoneNumber: value.trim(),
            scId: Number(this.state.supplyCenterId['id']),
        };
        this.props
            .checkF1Number(params)
            .then((res) => {
                if (res && res.data && res.data.length > 0) {
                    let expressNumber = res.data[0].id;
                    this.setState(
                        {
                            expressNumber,
                            expressNumList: res.data,
                        },
                        () => {
                            this.e1GetSku();
                        },
                    );
                }
            })
            .catch((err) => {
                if (err.status === 'Invalid_F1_Number') {
                    this.clearF1data('host_abnormal_Invalid_F1_Number');
                } else if (err.status === 'No_Shipment') {
                    this.clearF1data('host_abnormal_No_Shipment');
                } else if (err.status === 'Mismatch_SC_F1Number') {
                    this.clearF1data('host_abnormal_Mismatch_SC_F1Number');
                } else if (err.status === 'Empty_Sc') {
                    this.clearF1data('host_abnormal_Empty_Sc');
                } else if (err.status === 'No_Match_SC_F1_Number') {
                    this.clearF1data('host_abnormal_No_Match_SC_F1_Number');
                } else {
                    this.clearF1data('host_abnormal_valid_F1_order_number');
                }
                this.setState({
                    expressNumber: '',
                });
            });
    };

    searchData = (value, type) => {
        const {
            supplyCenterlist,
            expressNumberList,
            scrapSkuList,
            scrapParamsList,
        } = this.props;
        if (typeof value == 'string') {
            if (type === 'sc') {
                let data =
                    supplyCenterlist &&
                    supplyCenterlist.length > 0 &&
                    supplyCenterlist.filter((item) => {
                        return item['fullName'].search(value) !== -1;
                    });
                this.setState({
                    SClist: data,
                });
            }
            if (type === 'dn') {
                let data =
                    expressNumberList &&
                    expressNumberList.length > 0 &&
                    expressNumberList.filter((item) => {
                        return item['fullName'].search(value) !== -1;
                    });
                this.setState({
                    expressNumList: data,
                });
            }
            if (type === 'sku') {
                let data =
                    scrapSkuList &&
                    scrapSkuList.length > 0 &&
                    scrapSkuList.filter((item) => {
                        return item['fullName'].search(value) !== -1;
                    });
                this.setState({
                    refundSkuList: data,
                });
            }
            if (type === 'lot') {
                let data =
                    scrapParamsList &&
                    scrapParamsList.length > 0 &&
                    scrapParamsList.filter((item) => {
                        return item['fullName'].search(value) !== -1;
                    });
                this.setState({
                    lotList: data,
                });
            }
        }
    };

    getSKU = (value) => {
        const {supplyCenterId} = this.state;
        let skuData = [];
        const params = {
            scId: supplyCenterId['id'],
            queryKey: value,
        };
        if (!supplyCenterId || supplyCenterId == '') {
            return;
        } else {
            this.props.getVagueSearchList(params).then((res) => {
                if (
                    res &&
                    res['status'] == 'success' &&
                    res['data'].length > 0
                ) {
                    res['data'].forEach((items, index) => {
                        skuData.push({
                            id: index,
                            fullName: items['kitDisplay'],
                            lot: items['item'],
                        });
                    });

                    if (skuData.length > 0) {
                        skuData.forEach((item) => {
                            item['lot'].forEach((i) => {
                                i['key'] = i['lot'];
                                i['value'] = i['lot'];
                            });
                        });
                    }

                    this.setState({
                        skuData,
                    });
                } else if (
                    res &&
                    res['status'] == 'success' &&
                    res['data'].length <= 0
                ) {
                    this.setState({
                        skuData: [],
                    });
                }
            });
        }
    };

    focusInput = (type) => {
        const {eoneNumber} = this.state;
        if (type == 'sc') {
            this.setState({
                SClist: this.props.supplyCenterlist,
            });
        } else if (type == 'scrap') {
            this.setState({
                scrapTypelist: this.props.scrapType,
            });
        } else if (type == 'dn') {
            const {expressNumberList} = this.props;
            if (eoneNumber.length == 0) {
                this.setState({
                    expressNumList: [],
                    expressNumber: '',
                });
            } else {
                this.setState({
                    expressNumList: expressNumberList,
                });
            }
        } else if (type == 'sku') {
            const {scrapSkuList} = this.props;
            if (eoneNumber.length == 0) {
                this.setState({
                    refundSkuList: [],
                });
            } else {
                this.setState({
                    refundSkuList: scrapSkuList,
                });
            }
        } else if (type == 'lot') {
            const {scrapParamsList} = this.props;
            if (eoneNumber.length == 0) {
                this.setState({
                    lotList: [],
                });
            } else {
                this.setState({
                    lotList: scrapParamsList,
                });
            }
        }
    };

    handleTextArea = (name, value) => {
        if (value && value.length > 0) {
            let num = value && value.length;
            if (num >= 200) {
                num = 200;
            }

            this.setState({
                remarkNum: num,
                abnormalDescription: value,
            });
        }
    };

    clearInput = () => {
        this.setState({
            remarkNum: 0,
            abnormalDescription: '',
        });
    };

    changeNum = (value) => {
        if (value <= 1) {
            this.setState({
                quantity: 1,
            });
        } else {
            this.setState({
                quantity: value,
            });
        }
    };

    chooseImage = (item) =>
        this.refs['inputFile'] && this.refs['inputFile'].click();

    selectedImage = (ev) => {
        if (!ev.target.files && !ev.target.files[0]) return;
        const reader = new FileReader();
        const file = ev.target.files[0];

        reader.onload = (ev) => {
            this.setState({chooseImage: {file, url: ev.target.result}});
        };

        reader.readAsDataURL(file);
    };

    submitSave = () => {
        this.setState({loading: true});
        this.props
            .uploadReceiveImage({
                type: 'abnormal',
                file: this.state.chooseImage.file,
            })
            .then((res) => {
                const params = {};
                let kitSku = '';
                if (this.state.kitSku == '') {
                    kitSku =
                        this.state.sku.lot &&
                        this.state.sku.lot.length > 0 &&
                        this.state.sku.lot[0].kitSku;
                }
                let sku = '';
                if (this.state.type && this.state.type.key === 'REFUND') {
                    sku = this.state.refund_sku && this.state.refund_sku.sku;
                } else {
                    if (typeof this.state.sku == 'object') {
                        sku =
                            this.state.sku.lot &&
                            this.state.sku.lot.length > 0 &&
                            this.state.sku.lot[0].sku;
                    } else {
                        sku = this.state.sku;
                    }
                }
                params.sku = sku;
                params.kitSku =
                    this.state.kitSku == '' ? kitSku : this.state.kitSku;
                params.abnormalDescription = this.state.abnormalDescription;
                params.quantity = this.state.quantity;
                params.pic = res.url;
                params.lotNo = this.state.lotNo;
                params.expireDate = this.state.expireDate;
                params.supplyCenterId = Number(this.state.supplyCenterId['id']);
                params.type = (this.state.type && this.state.type.key) || '';

                if (this.state.eoneNumber !== '') {
                    params.eoneNumber = this.state.eoneNumber;
                } else {
                    delete params.eoneNumber;
                }

                if (this.state.expressNumber !== '') {
                    params.expressNumber = this.state.expressNumber;
                } else {
                    delete params.expressNumber;
                }

                this.props
                    .saveAbnormalRecord(params)
                    .then(() => {
                        this.setState({
                            sku: '',
                            kitSku: '',
                            abnormalDescription: '',
                            quantity: 1,
                            baseQuantity: '',
                            pic: '',
                            lotNo: '',
                            expireDate: '',
                            supplyCenterId: '',
                            loading: false,
                            type: '',
                            refund_sku: [],
                        });

                        this.setState({loading: false});
                        this.props.openNotification(
                            T('notification_add_a_success'),
                            'success',
                        );
                        this.props.history.replace('/abnormalRecordList');
                    })
                    .catch((e) => {
                        if (
                            e['message'] ==
                            'to be scrapped quantity is not greater than actually inventory'
                        ) {
                            this.props.openNotification(
                                T(
                                    'scrapped_quantity_is_not_greater_than_actually_inventory',
                                ),
                                'danger',
                            );
                        } else if (e.status === 'Empty_F1_Number') {
                            this.props.openNotification(
                                T('host_abnormal_Empty_f1_number'),
                                'danger',
                            );
                        } else if (e.status === 'Not_Exist_F1_Number') {
                            this.props.openNotification(
                                T('host_abnormal_f1_number_null'),
                                'danger',
                            );
                        } else if (e.status === 'Empty_Express_Number') {
                            this.props.openNotification(
                                T('host_abnormal_express_number_null'),
                                'danger',
                            );
                        } else if (e.status === 'Not_Exist_Express_Number') {
                            this.props.openNotification(
                                T('host_abnormal_express_number_no'),
                                'danger',
                            );
                        } else if (e.status === 'Quantity_Over_Received') {
                            this.props.openNotification(
                                T('host_abnormal_scrap_greater_receiving'),
                                'danger',
                            );
                        } else if (e.status === 'No_Match_SKU_LOT') {
                            this.props.openNotification(
                                T('host_abnormal_sku_lot_matching'),
                                'danger',
                            );
                        } else {
                            this.props.openNotification(
                                T('notification_addition_failed'),
                                'danger',
                            );
                        }
                        this.setState({loading: false});
                    });
            })
            .catch(() => {
                this.setState({loading: false});
                this.props.openNotification(
                    T('notification_picture_upload_failed'),
                    'danger',
                );
            });
    };

    render() {
        const {
            sku,
            abnormalDescription,
            quantity,
            chooseImage,
            supplyCenterId,
            loading,
            skuData,
            lotData,
            expireDate,
            SClist,
            scrapTypelist,
            type,
            eoneNumber,
            expressNumber,
            expressNumList,
            refundSkuList,
            lotNo,
            lotList,
            baseQuantity,
            remarkNum,
        } = this.state;
        const {supplyCenterlist, scrapType} = this.props;
        let isSave = true;
        if (type && type.key === 'REFUND') {
            isSave = !(
                sku !== '' &&
                abnormalDescription !== '' &&
                quantity > 0 &&
                chooseImage !== null &&
                supplyCenterId !== '' &&
                expireDate !== '' &&
                type !== '' &&
                lotNo !== '' &&
                eoneNumber !== '' &&
                expressNumber !== ''
            );
        } else if (type && type.key !== 'REFUND') {
            isSave = !(
                sku !== '' &&
                abnormalDescription !== '' &&
                quantity > 0 &&
                chooseImage !== null &&
                supplyCenterId !== '' &&
                expireDate !== '' &&
                type !== '' &&
                lotNo !== ''
            );
        }
        let lang = loadLanguage();
        return (
            <div className="abnormal-record-save">
                <Grid
                    className="ship-to-head container-max-width is-fixed"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="back-icon" item xs={3}>
                        <Anchor
                            onClickOfSingleTap={() =>
                                this.props.history.replace(
                                    '/abnormalRecordList',
                                )
                            }>
                            <IconButton color="inherit">
                                <ArrowBackIos />
                            </IconButton>
                        </Anchor>
                    </Grid>

                    <Grid
                        className={util.getClassName({
                            'page-title': true && lang !== 'EN',
                            'en-page-title': true && lang === 'EN',
                        })}
                        item
                        xs={9}>
                        <span>{T('host_abnormal_reagent_add')}</span>
                    </Grid>
                </Grid>

                <div className="content">
                    <section className="content-box abnormal-record-basicselect">
                        <Grid container spacing={0} justify={'center'}>
                            <Grid item xs={12}>
                                {supplyCenterlist &&
                                supplyCenterlist.length > 0 ? (
                                    <SelectInput
                                        title={'supplyCenterId'}
                                        placeholder={
                                            'host_abnormal_selece_scName'
                                        }
                                        list={SClist}
                                        value={this.state.supplyCenterId}
                                        inputValid={this.handleChange}
                                        type="text"
                                        required="true"
                                        focusInput={() => {
                                            this.focusInput('sc');
                                        }}
                                    />
                                ) : null}
                            </Grid>
                            <Grid item xs={12}>
                                {scrapType && scrapType.length > 0 ? (
                                    <SelectInput
                                        title={'abnormal_scrapSort'}
                                        placeholder={
                                            'host_abnormal_scrap_sort_placeholder'
                                        }
                                        list={scrapTypelist}
                                        value={this.state.type}
                                        inputValid={this.handleChange}
                                        type="text"
                                        required="true"
                                        focusInput={() => {
                                            this.focusInput('scrap');
                                        }}
                                    />
                                ) : null}
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="abnormal-record-f1-order">
                                {type && type.key === 'REFUND' ? (
                                    <BasicInput
                                        title={'abnormal_f1OrderNumber'}
                                        placeholder={
                                            'host_abnormal_f1_order_number_placeholder'
                                        }
                                        type="text"
                                        inputValid={this.handleChange}
                                        value={eoneNumber}
                                        required="true"
                                        onBlur={this.onBlur}
                                    />
                                ) : null}
                            </Grid>
                            <Grid item xs={12}>
                                {type && type.key === 'REFUND' ? (
                                    <SelectInput
                                        title={'abnormal_DnOrderNumber'}
                                        placeholder={
                                            'host_abnormal_dn_order_number_placeholder'
                                        }
                                        list={expressNumList}
                                        value={expressNumber}
                                        inputValid={this.handleChange}
                                        type="text"
                                        required="true"
                                        focusInput={() => {
                                            this.focusInput('dn');
                                        }}
                                    />
                                ) : null}
                            </Grid>
                            <Grid item xs={12}>
                                {type && type.key === 'REFUND' ? (
                                    <SelectInput
                                        title={'refund_sku'}
                                        placeholder={'backup_please_input_sku'}
                                        list={refundSkuList}
                                        value={sku}
                                        inputValid={this.handleChange}
                                        focusInput={() => {
                                            this.focusInput('sku');
                                        }}
                                        type="text"
                                        required="true"
                                    />
                                ) : (
                                    <SelectInput
                                        title={'sku'}
                                        placeholder={'backup_please_input_sku'}
                                        list={skuData}
                                        value={this.state.sku}
                                        inputValid={this.handleChange}
                                        type="text"
                                        required="true"
                                    />
                                )}
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="abnormal-record-select-content">
                                {type && type.key === 'REFUND' ? null : (
                                    <div>
                                        <label className="required-label">
                                            *
                                        </label>
                                        <label>{T('lotNo')}</label>
                                    </div>
                                )}
                                {type && type.key === 'REFUND' ? (
                                    <SelectInput
                                        title={'refund_lot'}
                                        placeholder={'backup_please_input_lot'}
                                        list={lotList}
                                        value={lotNo}
                                        inputValid={this.handleChange}
                                        focusInput={() => {
                                            this.focusInput('lot');
                                        }}
                                        type="text"
                                        required="true"
                                    />
                                ) : (
                                    <Select
                                        className="select"
                                        placeholder={T(
                                            'backup_please_input_lot',
                                        )}
                                        value={this.state.lotNo}
                                        data={lotData}
                                        displayKey="lot"
                                        valueKey="key"
                                        onChange={(value) => {
                                            this.handleChange(
                                                'lotNo',
                                                value.lot,
                                            );
                                        }}
                                        options={{
                                            icon: {
                                                show: true,
                                                color: '#E82D38',
                                            },
                                        }}
                                    />
                                )}
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="abnormal-record-content">
                                <BasicInput
                                    title={'expireDate'}
                                    type={'date'}
                                    inputValid={this.handleChange}
                                    value={expireDate}
                                    required="true"
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="abnormal-record-infor-box">
                                <div className="abnormal-record-infor">
                                    <label className="abnormal-record-infor-title">
                                        <span className="form-required">*</span>
                                        {T('host_abnormal_amount')}
                                    </label>
                                </div>
                                <div className="abnormal-record-infor">
                                    <Counter
                                        inputValid={this.changeNum}
                                        defalutValue={quantity}
                                        options={{
                                            value: {quantity},
                                            min: 1,
                                            max:
                                                type && type.key === 'REFUND'
                                                    ? baseQuantity
                                                    : null,
                                        }}></Counter>
                                </div>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="abnormal-record-remark-row">
                                <BasicTextArea
                                    type="text"
                                    title={'abnormalDescription'}
                                    inputValid={this.handleTextArea}
                                    clearInput={this.clearInput}
                                    maxlength={200}
                                    defalutValue=""
                                    value={abnormalDescription}
                                    required="true"
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="abnormal-record-remark">
                                {remarkNum}/200
                            </Grid>
                        </Grid>
                    </section>
                </div>

                <div className="abnormal-record-save-content">
                    <section className="content-box">
                        <Grid container spacing={0} justify={'center'}>
                            <Anchor
                                className={util.getClassName({
                                    'select-image-btn text-center':
                                        true && lang !== 'EN',
                                    'en-select-image-btn text-center':
                                        true && lang === 'EN',
                                })}
                                onClickOfSingleTap={this.chooseImage}>
                                {chooseImage && chooseImage.url ? (
                                    <img src={chooseImage.url} alt="" />
                                ) : (
                                    <span className="upload_here">
                                        {T('host_abnormal_upload_here')}
                                    </span>
                                )}
                                <input
                                    ref="inputFile"
                                    type="file"
                                    accept="image/*"
                                    onChange={this.selectedImage}
                                />
                            </Anchor>
                        </Grid>
                    </section>
                </div>

                <Grid
                    className="confirm-select"
                    container
                    spacing={0}
                    justify={'center'}>
                    <Grid item xs={11}>
                        <BasicButton
                            className={util.getClassName({
                                'btn-width': true && lang !== 'EN',
                                'en-btn-width': true && lang === 'EN',
                            })}
                            type="primary"
                            loading={loading}
                            disabled={!isSave ? false : true}
                            onClickOfSingleTap={this.submitSave}>
                            <span>{T('host_abnormal_confirm_add')}</span>
                        </BasicButton>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        supplyCenterlist: host.supplyCenterlist,
        skuVagueSearchData: host.skuVagueSearchData,
        scrapType: host.scrapType,
        expressNumberList: host.expressNumberList,
        scrapSkuList: host.scrapSkuList,
        scrapParamsList: host.scrapParamsList,
    };
};

const mapDispatchToProps = {
    saveAbnormalRecord,
    uploadReceiveImage,
    openNotification,
    getSupplyCenterList,
    getVagueSearchList,
    getScrapType,
    checkF1Number,
    e1GetSkuList,
    getScrapParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbnormalRecordSave);
